import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
interface SuccessScreenProps {
  onBackToHome: () => void;
}
export function SuccessScreen({
  onBackToHome
}: SuccessScreenProps) {
  return <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4" data-id="element-146">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center" data-id="element-147">
        <div className="mb-6 flex justify-center" data-id="element-148">
          <CheckCircle2Icon className="h-16 w-16 text-green-600" data-id="element-149" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-150">
          ✅ Confirming Payment!
        </h1>
        <p className="text-gray-700 mb-8" data-id="element-151">
          Your GreenHS VIP access will be activated for 30 days.
        </p>
        <div className="space-y-3" data-id="element-152">
          <a href="https://t.me/m/OJ7_4ex5MzM0" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition" data-id="element-153">
            Join VIP Channel
          </a>
          <button onClick={onBackToHome} className="block w-full bg-gray-200 text-gray-800 py-3 px-4 rounded-lg hover:bg-gray-300 transition" data-id="element-154">
            Back to Home
          </button>
        </div>
      </div>
    </div>;
}